// Shared by the root layout (a Server Component) and the client-side sidebar
// hook. Deliberately not a "use client" module: a Server Component importing
// from one receives client references, not these string values.

export const SIDEBAR_STORAGE_KEY = "floats:sidebar-state";

// Matches MUI's `theme.breakpoints.down("lg")`, used by the dashboard layout.
export const SIDEBAR_NARROW_QUERY = "(max-width: 1199.95px)";

// Resolve the sidebar's visible state before first paint. This must be emitted
// as a plain inline <script> in the server-rendered HTML — `next/script` with
// `beforeInteractive` is deferred until the Next runtime loads in the App
// Router, which lets the drawer paint collapsed and animate open. Narrow
// viewports force compact; otherwise honour a saved preference, falling back
// to the true default (open).
export const SIDEBAR_BOOTSTRAP_SCRIPT = `try{var saved=localStorage.getItem(${JSON.stringify(SIDEBAR_STORAGE_KEY)});var state=matchMedia(${JSON.stringify(SIDEBAR_NARROW_QUERY)}).matches?"collapsed":(saved==="open"||saved==="collapsed"?saved:"open");document.documentElement.dataset.floatsSidebarState=state}catch(e){}`;
